import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=03cf7940&scoped=true&"
import script from "./Embed.vue?vue&type=script&lang=js&"
export * from "./Embed.vue?vue&type=script&lang=js&"
import style0 from "./Embed.vue?vue&type=style&index=0&id=03cf7940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf7940",
  null
  
)

export default component.exports